import React, { useEffect, useState } from "react";

import SuggestedVideosColumn from "../../components/suggested-videos-column/suggested-videos-column.component";
import {
	SuggestedVideosContainer,
	ButtonContainer,
} from "./suggested-videos-page.styles";
import RoundedButton from "../../components/rounded-button/rounded-button.component";
import { Link } from "react-router-dom";
import SearchBarWithResults from "../../components/search-bar-with-results/search-bar-with-results.component";
import { useSelector } from "react-redux";
import { selectParentAppOS } from "../../redux/metadata/metadata.selector";

const SuggestedVideosPage = props => {
	const [hitsAreHidden, setHitsAreHidden] = useState(true);

	const parentOS = useSelector(selectParentAppOS);
	useEffect(() => {
		return () => {
			window.scrollTo(0, 0);
		}; //this will fire on component will unmount
	});

	return (
		<div>
			<ButtonContainer>
				{/*{!(parentOS === "android") ? (
					 <Link to="/grammar-page">
						<RoundedButton styles="background-color:gray;">
							Grammar
						</RoundedButton>
					</Link> 
				) : null}*/}
				<Link to="/subscriptions">
					<RoundedButton styles="background-color:gray;">
						Pricing
					</RoundedButton>
				</Link>
			</ButtonContainer>
			{!(parentOS === "android") ? (
				<SearchBarWithResults
					onHitsHiding={() => setHitsAreHidden(true)}
					onHitsShowing={() => setHitsAreHidden(false)}
				></SearchBarWithResults>
			) : null}
			{hitsAreHidden ? (
				<SuggestedVideosContainer>
					<SuggestedVideosColumn $columnCount={2} {...props} />
				</SuggestedVideosContainer>
			) : null}
		</div>
	);
};

export default SuggestedVideosPage;
